export default "__VITE_PUBLIC_ASSET__13e07fa3__"